import styled from 'styled-components';
import { pxToRem } from 'modules/spacing';
import { theme } from 'modules/tetrisTheme';
export const Icon = styled.span `
  flex: none;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: ${theme.spacing.lg};
  height: ${theme.spacing.lg};
  font-size: ${theme.fontSize.tiny};
  --falcon-size: ${theme.fontSize.tiny};
`;
export const Secondary = styled.span `
  flex: none;
  color: ${theme.semantic.foreground.muted};
  line-height: ${theme.lineHeight.neutralized};
`;
export const Title = styled.span `
  min-width: 0;
  max-width: 32ch;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: ${theme.lineHeight.neutralized};
`;
/**
 * Sized in `em` so the pill follows the surrounding text, and 1.38em tall so it
 * fits a 140% line box without growing it.
 */
export const Root = styled.a `
  display: inline-flex;
  align-items: center;
  gap: ${theme.spacing.sm};
  box-sizing: border-box;
  max-width: 100%;
  padding: ${theme.spacing.xs} ${theme.spacing.sm};
  vertical-align: baseline;
  white-space: nowrap;
  font-size: inherit;
  font-weight: ${theme.fontWeight.regular};
  line-height: ${theme.lineHeight.none};
  color: ${theme.semantic.foreground.primary};
  text-decoration: none;
  background-color: ${theme.semantic.surface.sunken};
  border: ${pxToRem(1)} solid ${theme.semantic.border.subtle};
  border-radius: ${theme.borderRadius.xs};
  transition:
    background-color ${theme.motion.duration.xfast} ${theme.motion.easing.standard},
    border-color ${theme.motion.duration.xfast} ${theme.motion.easing.standard};
  cursor: pointer;

  &:hover {
    background-color: ${theme.swatches.warm[75]};
    border-color: ${theme.semantic.border.default};
  }

  &:focus-visible {
    outline: none;
    box-shadow: 0 0 0 ${pxToRem(2)} ${theme.semantic.focus.ring};
  }
`;
